import { ImageResource } from "../../../ResourceManager/ImageResource";
import { Resourceful, Resourceful2 } from "../../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../../../ResourceManager/ResourceManager";
import { BonusFinish, IBonusStartConfig } from "../../../slot/SlotGame";
import { Size } from "../../.././MyHelpers";
import { SlotBonus3 } from "../SlotBonus3";
import { SlotBonusParams } from "../SlotBonusParams";
import { Settings } from "../../../Settings";
import { BigSymbolFreegamesCommonConfiguration } from "../../../api";

export interface BigSymbolFreegames3Params extends SlotBonusParams {
    readonly gameName: string;
    readonly gameBonusResourcesBasePath: string;
    readonly commonBonusResourcesBasePath: string
    readonly viewSize: Size;
    readonly bonusConfiguration: BigSymbolFreegamesCommonConfiguration;
}

export class BigSymbolFreegames3 extends SlotBonus3 implements Resourceful2 {

    public static readonly BonusName: string = "BigSymbolFreegames";

    protected view: HTMLElement = null;
    protected override resid: ResourceIdentifier;
    protected override parentresid: ResourceIdentifier = null;
    protected basepath: string = null;

    protected params: BigSymbolFreegames3Params = null;
    protected gameBonusResourcesBasePath: string;
    protected commonBonusResourcesBasePath: string;
    protected viewSize: Size;

    //protected moneyFormatter: MoneyFormatter = null;
	//protected translator: Translator;
	
	public BonusName(): string
	{
		return "BigSymbolFreegames";
	}

    constructor(gameResid: ResourceIdentifier, params: BigSymbolFreegames3Params) {
        super(params.gameName, params);

        this.parentresid = gameResid;
        this.resid = gameResid.Add(this.bonusName + "3");

        this.params = params;
        this.gameBonusResourcesBasePath = params.gameBonusResourcesBasePath;
        this.commonBonusResourcesBasePath = params.commonBonusResourcesBasePath;
        this.viewSize = params.viewSize;

        this.basepath = Settings.ResourcesFolder + "multigame/slot/" + params.gameName + "/";

        this.view = document.createElement("div");
        this.view.classList.add(this.resid.Scope());
        this.view.style.position = "absolute";
        this.view.style.top = "0px";
        this.view.style.left = "0px";
        this.view.style.width = this.viewSize.Width + "px";
        this.view.style.height = this.viewSize.Height + "px";
    }

    public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {
        //Yo
        //resourceManager.Add(new ImageResource(this.gameBonusResourcesBasePath + "background.3.png", this.resid.ScopedResourceName(["background3", "image"])));
        //Yo
    }

    public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
        //Yo
        // this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background3", "image"])).CssBackground();
        // this.view.style.backgroundSize = "contain";
		// this.view.style.backgroundRepeat = "no-repeat";
        //Yo
    }

    public OnBonusFinish(bonusFinish: BonusFinish): void {
    }

    public Prepare(bonusStartConfig: IBonusStartConfig): void {
    }

    public Hide(): void {
        this.view.style.visibility = "hidden";
    }

    public Show(): void {
        this.view.style.visibility = "visible";
    }

    public Update(): void {
    }

    public View(): HTMLElement {
        return this.view;
    }

    public Start(): void {
        this.Reset();
    }

    public Stop(): void {
    }

    public Reset(): void {
    }
}
